var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "m-2" },
    [
      _c("div", { staticClass: "d-flex flex-row mb-2" }, [
        _c("div", { staticClass: "btn-group ml-auto" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              on: {
                click: function($event) {
                  return _vm.store.reload(true)
                }
              }
            },
            [_c("i", { staticClass: "fa fa-sync" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              on: { click: _vm.newDefinition }
            },
            [_c("i", { staticClass: "fa fa-plus" })]
          )
        ])
      ]),
      _vm._v(" "),
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.store.definitions,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions
        },
        scopedSlots: _vm._u([
          {
            key: "emptystate",
            fn: function() {
              return [
                _c("CenterOnParent", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("txtSearchNoRows")) +
                      "\n      "
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "actions"
                  ? _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          on: {
                            click: function($event) {
                              return _vm.editDefinition(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-pen" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-danger",
                          on: {
                            click: function($event) {
                              return _vm.deleteDefinition(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash" })]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("DefinitionDeleteModal", { ref: "deleteModal" }),
      _vm._v(" "),
      _c("DefinitionEditModal", { ref: "editModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }